/* notifications: перевод строк интерфейса. Ключ — русская строка ровно как в коде.
   Уведомления (колокольчик + настройки), виджет «Идея / проблема» и журнал замечаний, журнал действий, моки окна «Настройки». */
const d: Record<string, string> = {
  /* ── журнал действий: подписи действий ── */
  "Вход": "Sign-in",
  "Выход": "Sign-out",
  "Отказ во входе": "Sign-in denied",
  "Создан владелец": "Owner created",
  "Добавлен пользователь": "User added",
  "Изменён пользователь": "User updated",
  "Доступ отозван": "Access revoked",
  "Доступ возвращён": "Access restored",
  "Новое замечание": "New feedback",
  "Замечание изменено": "Feedback updated",
  "Замечание удалено": "Feedback deleted",
  "Передано роботу": "Handed to the robot",
  "Изменены настройки пространства": "Workspace settings changed",
  "Создана команда": "Team created",
  "Изменена команда": "Team updated",
  "Удалена команда": "Team deleted",
  "Добавлен контакт": "Contact added",
  "Изменён контакт": "Contact updated",
  "Удалён контакт": "Contact deleted",
  "Массовое действие с контактами": "Bulk action on contacts",
  "Добавлен этап": "Stage added",
  "Изменён этап": "Stage updated",
  "Удалён этап": "Stage deleted",
  "Создан тег": "Tag created",
  "Изменён тег": "Tag updated",
  "Удалён тег": "Tag deleted",
  "Добавлено поле": "Field added",
  "Изменено поле": "Field updated",
  "Удалено поле": "Field deleted",
  "Запущен импорт": "Import started",
  "Импорт завершён": "Import finished",
  "Запрошена выгрузка": "Export requested",
  "Скачана выгрузка": "Export downloaded",

  /* ── журнал действий: детали ── */
  "сменить этап": "change stage",
  "сменить ответственного": "change assignee",
  "сменить команду": "change team",
  "добавить тег": "add tag",
  "снять тег": "remove tag",
  "заблокировать": "block",
  "разблокировать": "unblock",
  "удалить": "delete",
  "название": "name",
  "адрес": "address",
  "язык": "language",
  "часовой пояс": "time zone",
  "тайм-аут, мин": "timeout, min",
  "дайджест": "digest",
  "получатели дайджеста": "digest recipients",
  "описание": "description",
  "сайт": "website",
  "отрасль": "industry",
  "размер": "size",
  "почта для уведомлений": "notification email",
  "Все": "All",
  "Входы": "Sign-ins",
  "Пользователи": "Users",
  "Замечания": "Feedback",
  "Настройки": "Settings",
  "Команды": "Teams",
  "Контакты": "Contacts",
  "Импорт": "Import",
  "Экспорт": "Export",
  "оплата": "billing",
  "каналы": "channels",
  "участники": "members",
  "экспорт": "export",
  "приглашён": "invited",
  "активен": "active",
  "отключён": "disabled",
  "роль": "role",
  "права": "permissions",
  "статус": "status",
  "имя": "name",
  "роль: {role}": "role: {role}",
  "доступ отозван": "access revoked",
  "почта не добавлена": "email not added",
  "№{id}": "#{id}",
  "вкл.": "on",
  "выкл.": "off",
  "добавлены": "added",
  "убраны": "removed",
  "изменено": "changed",
  "{n} шт.": "{n} items",
  "контакты ({n}) перенесены на «{to}»": "contacts ({n}) moved to \"{to}\"",
  "снят с {n} контактов": "removed from {n} contacts",
  "строк: {n}": "rows: {n}",
  "создано {created}, обновлено {updated}, пропущено {skipped}": "created {created}, updated {updated}, skipped {skipped}",
  "контакты": "contacts",
  "через {source}": "via {source}",
  "Журнал действий": "Activity log",
  "Входы и отказы во входе, пользователи, роли и права, настройки, команды, контакты, этапы, теги, поля, импорт и экспорт, замечания. Записи нельзя изменить или удалить.":
    "Sign-ins and denied sign-ins, users, roles and permissions, settings, teams, contacts, stages, tags, fields, import and export, feedback. Entries cannot be edited or deleted.",
  "Почта": "Email",
  "Поиск по почте": "Search by email",
  "Записей не найдено.": "No entries found.",
  "система": "system",
  "Показать ещё": "Show more",
  "Загрузка…": "Loading…",

  /* ── журнал замечаний ── */
  "Новые": "New",
  "В работе": "In progress",
  "Исправлено": "Fixed",
  "Принято": "Accepted",
  "Отклонено": "Rejected",
  "низкий": "low",
  "обычный": "normal",
  "высокий": "high",
  "критичный": "critical",
  "в очереди робота": "queued for the robot",
  "робот исправляет": "robot is fixing",
  "робот не справился": "robot failed",
  "приоритет": "priority",
  "комментарий": "comment",
  "робот": "robot",
  "скриншот: python3 backend/scripts/tickets.py show {id}": "screenshot: python3 backend/scripts/tickets.py show {id}",
  "без скриншота": "no screenshot",
  "Экран": "Screen",
  "окно": "window",
  "Текст": "Text",
  "# Журнал замечаний Hub (hub.starec.ai)": "# Hub feedback log (hub.starec.ai)",
  "Исправь по порядку. Подробности и снимок: `python3 backend/scripts/tickets.py show N`; после исправления — `tickets.py status N testing \"что изменилось\"`.":
    "Fix in order. Details and screenshot: `python3 backend/scripts/tickets.py show N`; once fixed — `tickets.py status N testing \"what changed\"`.",
  "В журнале нет открытых замечаний": "There is no open feedback in the log",
  "Промпт для Claude Code скопирован": "Claude Code prompt copied",
  "Браузер не дал доступ к буферу обмена": "The browser denied clipboard access",
  "Журнал замечаний": "Feedback log",
  "Идеи и проблемы пользователей с плашки обратной связи: скриншот экрана, размер окна и сам текст. «Запустить исправление» передаёт замечание роботу Claude Code.":
    "Users' ideas and issues from the feedback widget: screenshot, window size and the text itself. \"Start fix\" hands the item to the Claude Code robot.",
  "Ваши идеи и проблемы с плашки обратной связи. Когда замечание исправят, проверьте и примите его или верните в работу с комментарием.":
    "Your ideas and issues from the feedback widget. Once an item is fixed, check it and accept it or return it to work with a comment.",
  "всего": "total",
  "Робот Claude Code": "Claude Code robot",
  "в очереди {n}": "{n} queued",
  "очередь пуста": "queue is empty",
  "Проверяет очередь каждые 10 минут: берёт одно замечание, правит код, прогоняет проверки, выкладывает и ставит «Исправлено — проверьте».":
    "Checks the queue every 10 minutes: takes one item, edits the code, runs the checks, deploys and sets \"Fixed — please verify\".",
  "Не справился с замечаниями: {n} — см. пометку в карточке.": "Failed on {n} item(s) — see the note on the card.",
  "Копировать промпт": "Copy prompt",
  "Обновить": "Refresh",
  "правки выкладываются только после проверок": "changes are deployed only after the checks pass",
  "Поиск или №": "Search or #",
  "Поиск по журналу замечаний": "Search the feedback log",
  "Здесь пока пусто": "Nothing here yet",
  "Нажмите плашку «Идея / проблема» в углу страницы, опишите замечание и приложите скриншот — запись появится в журнале.":
    "Click the \"Idea / issue\" button in the corner of the page, describe the item and attach a screenshot — it will appear in the log.",
  "приоритет: {p}": "priority: {p}",
  "Открыть скриншот замечания №{id}": "Open screenshot of feedback #{id}",
  "Скриншот экрана «{screen}»": "Screenshot of \"{screen}\"",
  "вы": "you",
  "комментариев: {n}": "comments: {n}",
  "Замечание исправлено. Проверьте на экране «{screen}» и нажмите «Принять» или верните в работу с комментарием.":
    "This item has been fixed. Check it on the \"{screen}\" screen and click \"Accept\", or return it to work with a comment.",
  "Замечание №{id} поставлено в очередь робота": "Feedback #{id} queued for the robot",
  "Запустить ещё раз": "Run again",
  "Запустить исправление": "Start fix",
  "Отмечено «Исправлено» — автор увидит и проверит": "Marked \"Fixed\" — the author will see and verify it",
  "Приоритет изменён": "Priority changed",
  "Приоритет": "Priority",
  "Замечание отклонено": "Feedback rejected",
  "Отклонить": "Reject",
  "Замечание вернули в новые": "Feedback returned to new",
  "Вернуть в новые": "Return to new",
  "Спасибо! Замечание принято": "Thank you! Feedback accepted",
  "Принять": "Accept",
  "Напишите в комментарии, что осталось не так, и нажмите «Вернуть в работу» ещё раз": "Write in a comment what is still wrong and click \"Return to work\" again",
  "Замечание возвращено в работу": "Feedback returned to work",
  "Вернуть в работу": "Return to work",
  "Удалить": "Delete",
  "Свернуть": "Collapse",
  "История и комментарии": "History and comments",
  "Истории пока нет.": "No history yet.",
  "Что осталось не так? Комментарий нужен, чтобы вернуть в работу": "What is still wrong? A comment is required to return it to work",
  "Комментарий или вопрос": "Comment or question",
  "Комментарий добавлен": "Comment added",
  "Отправить": "Send",
  "Робот берёт только замечания, которые администратор передал кнопкой «Запустить исправление». «Принято» ставит только автор замечания.":
    "The robot only takes items an admin handed over with \"Start fix\". Only the author can set \"Accepted\".",
  "Скриншот замечания": "Feedback screenshot",
  "Закрыть скриншот": "Close screenshot",
  "Скриншот экрана из журнала замечаний": "Screenshot from the feedback log",

  /* ── настройки уведомлений ── */
  "Браузер не поддерживает всплывающие уведомления": "This browser does not support push notifications",
  "Браузерные уведомления включены — не забудьте сохранить": "Browser notifications enabled — don't forget to save",
  "Браузер не дал разрешение — включите его в настройках сайта": "The browser denied permission — enable it in the site settings",
  "Настройки уведомлений вернули к значениям по умолчанию": "Notification settings reset to defaults",
  "Уведомления": "Notifications",
  "Выберите, куда и о чём присылать уведомления. Настройки применяются к вашему профилю, а не ко всему рабочему пространству.":
    "Choose where and what to notify you about. These settings apply to your profile, not to the whole workspace.",
  "Куда присылать": "Where to send",
  "включено {n} из {total}": "{n} of {total} on",
  "включено": "on",
  "выключено": "off",
  "Разрешение браузера получено — уведомления появятся, даже когда вкладка свёрнута.": "Browser permission granted — notifications will appear even when the tab is in the background.",
  "Для всплывающих окон браузер спросит разрешение — его можно отозвать в настройках сайта.": "The browser will ask for permission to show pop-ups — you can revoke it in the site settings.",
  "О чём присылать": "What to send",
  "Как часто": "How often",
  "Сразу": "Immediately",
  "Раз в час": "Hourly",
  "Дайджест в 9:00": "Digest at 9:00",
  "«Сразу» — по каждому событию, «Раз в час» — сборка, «Дайджест» — одно письмо утром.": "\"Immediately\" — one per event, \"Hourly\" — batched, \"Digest\" — a single email in the morning.",
  "Тихие часы": "Quiet hours",
  "включены": "on",
  "выключены": "off",
  "Тихие часы с": "Quiet hours from",
  "Тихие часы до": "Quiet hours to",
  "В это время всплывающие окна и письма не приходят — всё соберётся в одно письмо после тихих часов.": "No pop-ups or emails during this time — everything is collected into one email after quiet hours.",
  "Выберите хотя бы один способ доставки уведомлений": "Choose at least one delivery channel",
  "Настройки уведомлений сохранены · событий включено {n}": "Notification settings saved · {n} events on",
  "Сохранить": "Save",
  "Отправить тестовое": "Send a test",
  "Сбросить": "Reset",
  "Настройки касаются только вашего профиля; владелец пространства их не меняет.": "These settings affect only your profile; the workspace owner does not change them.",

  /* ── типы, каналы и события уведомлений ── */
  "Экспорт данных": "Data export",
  "Диалог": "Conversation",
  "Рассылка": "Broadcast",
  "Отчёт": "Report",
  "Интеграция": "Integration",
  "Команда": "Team",
  "Процесс": "Workflow",
  "Канал": "Channel",
  "Замечание": "Feedback",
  "Сегодня": "Today",
  "Вчера": "Yesterday",
  "Ранее": "Earlier",
  "Сегодня в {hm}": "Today at {hm}",
  "Вчера в {hm}": "Yesterday at {hm}",
  "{date} в {hm}": "{date} at {hm}",
  "Браузерные уведомления": "Browser notifications",
  "Всплывающее окно поверх вкладок, даже когда Hub свёрнут.": "A pop-up over your tabs, even when Hub is minimised.",
  "Письма на {email} — по выбранной частоте.": "Emails to {email} — at the frequency you choose.",
  "вашу почту": "your email",
  "Telegram-бот": "Telegram bot",
  "Короткие оповещения в личный чат с ботом рабочего пространства — заработает вместе с подключением Telegram.": "Short alerts in a private chat with the workspace bot — available once Telegram is connected.",
  "Новые диалоги и упоминания": "New conversations and mentions",
  "Клиент написал впервые или коллега упомянул вас в заметке.": "A client wrote for the first time or a colleague mentioned you in a note.",
  "Экспорты и отчёты": "Exports and reports",
  "Файл выгрузки готов, недельный отчёт собран.": "An export file is ready, the weekly report is compiled.",
  "Рассылки": "Broadcasts",
  "Отправка завершена, доставка и ошибки по получателям.": "Sending finished, delivery and errors per recipient.",
  "Рабочие процессы": "Workflows",
  "Процесс требует проверки или остановился на условии.": "A workflow needs review or stopped at a condition.",
  "Интеграции": "Integrations",
  "Синхронизация завершилась или вернула ошибку.": "A sync finished or returned an error.",
  "Команда и замечания": "Team and feedback",
  "Вас добавили в команду, новое замечание «Идея / Проблема» или ответ по нему.": "You were added to a team, new \"Idea / Issue\" feedback or a reply to it.",

  /* ── панель уведомлений ── */
  "Новый": "New",
  "Архив": "Archive",
  "Архивировать все": "Archive all",
  "Закрыть уведомления": "Close notifications",
  "Включите уведомления браузера об обновлениях. Вы можете изменить их в любое время в настройках уведомлений.": "Turn on browser notifications for updates. You can change this at any time in the notification settings.",
  "Позже": "Later",
  "Включить сейчас": "Enable now",
  "Новых уведомлений нет": "No new notifications",
  "Архив пуст": "Archive is empty",
  "Уведомлений пока нет": "No notifications yet",
  "Мы сообщим, когда экспорт будет готов, рассылка уйдёт или клиент долго ждёт ответа.": "We'll let you know when an export is ready, a broadcast is sent or a client has been waiting for a reply.",
  "Сюда попадают уведомления, которые вы убрали из новых.": "Notifications you removed from new end up here.",
  "Здесь появятся все события рабочего пространства.": "All workspace events will appear here.",
  "Не прочитано": "Unread",
  "Отметить прочитанным": "Mark as read",
  "Отметить «{title}» прочитанным": "Mark \"{title}\" as read",
  "Вернуть «{title}» в новые": "Return \"{title}\" to new",
  "Архивировать": "Archive",
  "Архивировать «{title}»": "Archive \"{title}\"",
  "Настройки уведомлений": "Notification settings",
  "Непрочитанных: {n}": "Unread: {n}",

  /* ── виджет «Идея / проблема» ── */
  "Идея": "Idea",
  "Чего не хватает в продукте": "What the product is missing",
  "Проблема": "Issue",
  "Что работает неправильно": "What works incorrectly",
  "Новое": "New",
  "Исправлено — проверьте": "Fixed — please verify",
  "Страница Hub": "Hub page",
  "Браузер не поддерживает съёмку экрана — прикрепите файл или вставьте картинку из буфера.": "This browser does not support screen capture — attach a file or paste an image from the clipboard.",
  "Съёмка экрана отменена. Можно прикрепить файл или вставить картинку из буфера.": "Screen capture cancelled. You can attach a file or paste an image from the clipboard.",
  "Не удалось снять экран. Прикрепите файл — замечание всё равно сохранится.": "Could not capture the screen. Attach a file — the feedback will still be saved.",
  "Нужна картинка: PNG, JPG или скриншот.": "An image is required: PNG, JPG or a screenshot.",
  "Не удалось прочитать файл. Попробуйте другой скриншот.": "Could not read the file. Try another screenshot.",
  "Опишите замечание хотя бы одним предложением — так роботу будет понятнее.": "Describe the item in at least one sentence — it helps the robot understand.",
  "Обратная связь: идея или проблема": "Feedback: idea or issue",
  "Обратная связь": "Feedback",
  "Замечание уйдёт в журнал, администратор передаст его роботу на исправление.": "The item goes to the log; an admin will hand it to the robot to fix.",
  "Закрыть форму обратной связи": "Close the feedback form",
  "Замечание в журнале": "Feedback logged",
  "Скриншот приложен.": "Screenshot attached.",
  "Администратор посмотрит его и передаст роботу. Когда будет исправлено, статус в журнале сменится на «Исправлено — проверьте».": "An admin will review it and hand it to the robot. Once fixed, the status in the log will change to \"Fixed — please verify\".",
  "Открыть журнал": "Open log",
  "Ещё одно": "Add another",
  "Тип замечания": "Feedback type",
  "Что пошло не так? На каком экране, что нажали и что ожидали увидеть.": "What went wrong? Which screen, what you clicked and what you expected to see.",
  "Чего не хватает и как это поможет в работе? Опишите сценарий.": "What is missing and how would it help your work? Describe the scenario.",
  "Скриншот прикладывается к записи": "The screenshot is attached to the entry",
  "Скриншот экрана, с которого отправляют замечание": "Screenshot of the screen the feedback is sent from",
  "Убрать скриншот": "Remove screenshot",
  "Скриншот экрана приложен": "Screenshot attached",
  "Скриншот экрана": "Screenshot",
  "Снимем текущий экран или приложим файл, можно вставить ⌘V.": "Capture the current screen or attach a file; you can also paste with ⌘V.",
  "Снимаю…": "Capturing…",
  "Снять экран": "Capture screen",
  "Прикрепить файл": "Attach file",
  "Отправить в журнал": "Send to log",
  "Журнал": "Log",
  "Свернуть форму обратной связи": "Collapse the feedback form",
  "Идея или проблема: обратная связь": "Idea or issue: feedback",
  "Идея / проблема": "Idea / issue",

  /* ── моки окна «Настройки»: разделы ── */
  "Основные настройки": "General settings",
  "Название, адрес и язык рабочего пространства — то, что видно в письмах и ссылках.": "Workspace name, address and language — what appears in emails and links.",
  "Общая информация": "Company info",
  "Описание компании, сайт и отрасль — помогают AI-ассистенту отвечать точнее.": "Company description, website and industry — they help the AI assistant answer more precisely.",
  "Настройки ролей пользователей": "User roles",
  "Что могут делать агенты, менеджеры и администраторы в рабочем пространстве.": "What agents, managers and admins can do in the workspace.",
  "Пользовательские настройки полей": "Custom fields",
  "Свои поля карточки клиента: город, номер договора, сегмент и любые другие.": "Your own contact card fields: city, contract number, segment and anything else.",
  "Настройки команды": "Team settings",
  "Команды группируют сотрудников, чтобы разом назначать им диалоги и контакты.": "Teams group employees so you can assign conversations and contacts to them at once.",
  "Приложения": "Apps",
  "Дополнительные приложения рабочего пространства — включайте нужные в один клик.": "Additional workspace apps — enable the ones you need in one click.",
  "Каналы": "Channels",
  "Управляйте своими каналами обмена сообщениями и открывайте новые, которые помогут вам привлечь больше клиентов.": "Manage your messaging channels and open new ones to reach more customers.",
  "Свяжите Hub с CRM, таблицами и складом — данные будут обновляться синхронно.": "Connect Hub to your CRM, spreadsheets and warehouse — data stays in sync.",
  "Куда и о чём присылать уведомления: браузер, почта, Telegram, частота и тихие часы.": "Where and what to notify you about: browser, email, Telegram, frequency and quiet hours.",
  "Идеи и проблемы пользователей со скриншотами экранов — отсюда робот Claude Code запускает исправления.": "Users' ideas and issues with screenshots — the Claude Code robot starts fixes from here.",
  "Входы, добавление пользователей, смена ролей и прав, отзыв доступа — кто и когда.": "Sign-ins, added users, role and permission changes, revoked access — who and when.",

  /* ── моки: часовые пояса ── */
  "(GMT+01:00) Европа/Рим": "(GMT+01:00) Europe/Rome",
  "(GMT+03:00) Европа/Москва": "(GMT+03:00) Europe/Moscow",
  "(GMT+00:00) Европа/Лондон": "(GMT+00:00) Europe/London",
  "(GMT+05:00) Азия/Алматы": "(GMT+05:00) Asia/Almaty",
  "(GMT+04:00) Азия/Дубай": "(GMT+04:00) Asia/Dubai",
  "(GMT−05:00) Америка/Нью-Йорк": "(GMT−05:00) America/New York",

  /* ── моки: каналы ── */
  "Мессенджер": "Messenger",
  "Обычный аккаунт по QR или номеру, либо официальный WABA": "Regular account via QR or phone number, or official WABA",
  "Аккаунт по QR-коду или бот по токену": "Account via QR code or a bot via token",
  "Вход в аккаунт по логину или через бизнес-страницу Facebook": "Sign in with your account or via a Facebook business page",
  "Аккаунт по QR-коду или официальный Viber Business по токену": "Account via QR code or official Viber Business via token",
  "Сообщения сообщества ВКонтакте": "VK community messages",
  "Маркетплейс": "Marketplace",
  "Переписка по объявлениям и заявки": "Listing conversations and enquiries",
  "Ящик по IMAP и SMTP с историей писем": "Mailbox via IMAP and SMTP with email history",
  "Сайт": "Website",
  "Виджет на сайте, ответы из Hub": "Website widget, replies from Hub",
  "Короткие уведомления и подтверждения": "Short alerts and confirmations",
  "Звонки": "Calls",
  "Входящие звонки и запись разговоров": "Incoming calls and call recording",

  /* ── моки: роли ── */
  "Свои диалоги": "Own conversations",
  "Все диалоги": "All conversations",
  "Оплата и тариф": "Billing and plan",
  "Агент": "Agent",
  "Отвечает клиентам в назначенных диалогах и ведёт карточки контактов.": "Replies to clients in assigned conversations and maintains contact cards.",
  "Менеджер": "Manager",
  "Видит все диалоги, распределяет их по продавцам и смотрит отчёты.": "Sees all conversations, distributes them among sellers and views reports.",
  "Администратор": "Admin",
  "Управляет каналами, участниками, интеграциями и оплатой.": "Manages channels, members, integrations and billing.",

  /* ── моки: приложения ── */
  "Календарь встреч": "Meeting calendar",
  "Продуктивность": "Productivity",
  "Свободные слоты в ленте диалога и ссылка на встречу в один клик.": "Free slots in the conversation feed and a meeting link in one click.",
  "Задачи": "Tasks",
  "Задача по диалогу с исполнителем и сроком, напоминание в чат.": "A task on a conversation with an assignee and due date, reminder in chat.",
  "Формы и заявки": "Forms and requests",
  "Продажи": "Sales",
  "Форма на сайте создаёт контакт и первый диалог автоматически.": "A website form creates a contact and the first conversation automatically.",
  "База знаний": "Knowledge base",
  "Поддержка": "Support",
  "Статьи для команды и источники знаний для AI Assist.": "Articles for the team and knowledge sources for AI Assist.",
  "Оценка качества": "Quality rating",
  "Оценка диалогов клиентом и разбор спорных ответов руководителем.": "Client ratings of conversations and manager review of disputed replies.",
  "Остатки и склад": "Stock and warehouse",
  "Актуальные остатки в карточке товара прямо во время переписки.": "Live stock levels on the product card right while chatting.",

  /* ── моки: интеграции ── */
  "Контакты и сделки синхронизируются в обе стороны, этапы воронки совпадают.": "Contacts and deals sync both ways; pipeline stages match.",
  "Битрикс24": "Bitrix24",
  "Диалоги Hub создают лиды и задачи в Битрикс24 без ручного переноса.": "Hub conversations create leads and tasks in Bitrix24 without manual entry.",
  "Google Таблицы": "Google Sheets",
  "Выгрузка контактов и отчётов в таблицу по расписанию.": "Scheduled export of contacts and reports to a spreadsheet.",
  "1С:Предприятие": "1C:Enterprise",
  "Заказы, оплаты и остатки из 1С в карточке клиента и в ответах продавца.": "Orders, payments and stock from 1C on the client card and in the seller's replies.",
  "Связка Hub с тысячами сервисов без разработки: события и действия по триггерам.": "Connect Hub to thousands of services without coding: trigger-based events and actions.",
  "Вебхуки и API": "Webhooks and API",
  "Свой сервис получает события сообщений и может отправлять ответы в Hub.": "Your own service receives message events and can send replies to Hub.",
  "Ключ hub_live_7f31…": "Key hub_live_7f31…",

  /* ── моки: подсказки ── */
  "Права по ролям": "Permissions by role",
  "Роль определяет доступ к каналам, настройкам и оплате — проверяйте её перед приглашением.": "The role defines access to channels, settings and billing — check it before inviting.",
  "Команды вместо людей": "Teams instead of people",
  "Назначайте диалоги и контакты целой команде, а не каждому сотруднику по отдельности.": "Assign conversations and contacts to a whole team rather than to each employee individually.",
  "Изменения сразу": "Changes apply instantly",
  "Настройки применяются к рабочему пространству сразу после сохранения — перезапуск не нужен.": "Settings apply to the workspace right after saving — no restart needed.",
  "Снимаем текущий экран…": "Capturing the current screen…",
  "Скриншот экрана приложен — робот увидит этот экран. Не тот? Уберите и снимите заново или приложите файл.": "Screenshot attached — the robot will see this screen. Wrong one? Remove it and capture again or attach a file.",
};
export default d;
